import { callCSSFn, CSS, CSSFn, StyleProps } from "../styles"

export const root =
  (css?: CSSFn) =>
  (props: StyleProps): CSS => ({
    zIndex: 17000,
    position: `relative`,
    "& .mdc-dialog .mdc-dialog__title, & .mdc-dialog .mdc-dialog__content": {
      color: props.theme.palette.coal.dark,
    },
    "& .mdc-dialog .mdc-dialog__surface": {
      maxWidth: `none`,
    },
    "& .mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title, & .mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions":
      {
        border: `none`,
      },
    ...callCSSFn({ ...props, css }),
  })

export const titleWrap = (): CSS => ({
  position: `relative`,
})

export const subTitle = (props: StyleProps): CSS => ({
  marginTop: props.theme.spacing(1),
})

export const closeIcon = (props: StyleProps): CSS => ({
  position: `absolute`,
  padding: `10px`,
  backgroundColor: props.theme.palette.white,
  height: `35px`,
  borderRadius: `50%`,
  top: props.theme.spacing(6),
  right: props.theme.spacing(7),
  "@media (max-width: 600px)": {
    top: `1rem`,
    right: `1.25rem`,
  },
})

export const separator = (props: StyleProps): CSS => ({
  marginLeft: props.theme.spacing(7),
})
